<app-dynamicstyle [orgId]="orgId"></app-dynamicstyle>
<div class="container-fluid p-0" *ngIf="showTopNav">
<nav class="navbar top-navbar navbar-expand-sm navbar-light bg-light sticky">
  <div class="navbar-brand mt-0 ml-0 mr-20px mb-3px p-0 position-absolute ps-t-10">
    <app-brand></app-brand>
  </div>
    <div class="navbar-collapse d-none d-md-block" id="navbarSupportedContent">
      <ul *ngIf="canEditOrg() && !viewAsCustomer" class="navbar-nav mr-auto ml-auto mt-0 align-items-center">
        <!---<li *ngIf="et_admin" class="nav-item not-active" routerLinkActive="active"> 
          <div class="svg-tab"></div>
          <a  class="nav-link hover" routerLink="/dashboard"><h2 routerLinkActive="active" class="nav-item-tabs item-control">Dashboard</h2></a>
        </li>--->
        <li *ngIf="et_admin" class="nav-item not-active" routerLinkActive="active"> 
          <div class="svg-tab"></div>
          <a  class="nav-link hover" routerLink="/admin"><h2 routerLinkActive="active" class="nav-item-tabs item-control">{{ 'topnav.admin' | trans }}</h2></a>
        </li>
        <li *ngIf="!noOrgYet()" class="nav-item not-active" routerLinkActive="active"> 
          <div class="svg-tab"></div>
          <a (click)="setLoader('projectlist')" class="nav-link hover" routerLink="/portal"><h2 routerLinkActive="active" class="nav-item-tabs item-control">{{ 'topnav.portal' | trans }}</h2></a>
        </li>
        <li *ngIf="!noOrgYet()" class="nav-item not-active" routerLinkActive="active">
          <div  class="svg-tab">
              </div>
          <a  class="nav-link hover" routerLink="/people"><h2 routerLinkActive="active" class="nav-item-tabs item-control">{{ 'topnav.people' | trans }}</h2></a>
      </li>
        <!----<li  *ngIf="modulePlanning && !noOrgYet()" class="nav-item not-active" routerLinkActive="active">
          <div  class="svg-tab">
              </div>
          <a class="nav-link hover" (click)="setLoader('planning')" routerLink="/planning"><h2 routerLinkActive="active" class="nav-item-tabs item-control">{{ 'topnav.planning' | trans }}</h2></a>
        </li> ---->
        <li *ngIf="!noOrgYet()"class="nav-item not-active" routerLinkActive="active">
          <div  class="svg-tab">
              </div>
          <a class="nav-link hover" (click)="setLoader('customerlist')" routerLink="/customers"><h2 routerLinkActive="active" class="nav-item-tabs item-control">{{ 'topnav.customers' | trans }}</h2></a>
        </li>
        <li *ngIf="!noOrgYet()" class="nav-item not-active" routerLinkActive="active">
          <div class="svg-tab">
              </div>
          <a class="nav-link hover" routerLink="/adhoc"><h2 routerLinkActive="active" class="nav-item-tabs item-control">{{ 'topnav.adhoc' | trans }}</h2></a>
        </li>
      </ul>
      
      <div class="user-container cursor-pointer">

        <div class="row">
          <div *ngIf="viewAsCustomer" class="col ng-star-inserted" (click)="disableCustomerView()">
            <span class="material-icons customer-icon"> visibility_off </span>
          </div>
          <div (click)="toggleChat()" class="col" style="padding-right:0px;">
            <span class="material-icons chat-icon">
              chat
            </span>  
          </div>
          <div class="col" style="padding-left:0px;">
            <app-notification [customerportal]="isCustomerPortal()"></app-notification>
          </div>
        </div>
        </div>
    </div> 
  </nav>
</div>




